export default "__VITE_ASSET__BULg0fWI__"